(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/hooks/assets/javascripts/use-current-tab.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/hooks/assets/javascripts/use-current-tab.js');
"use strict";

const {
  useContext
} = React;
const {
  playContext
} = svs.racing_game.components;
const {
  useNavigationState
} = svs.racing.navigation;
const isMobile = svs.core.detect.formfactor.mobile();
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const tabs = {
  MINA_SPEL: 'mina-spel',
  SPELANALYS_HIGH_FIVE: 'spelanlys-high-five',
  SPELGUIDE: 'spelguide',
  SPELA: 'spela'
};
const defaultTab = svs.racing_game.data.config.tabsConfig.defaultTab ? svs.racing_game.data.config.tabsConfig.defaultTab : tabs.MINA_SPEL;
const determineTab = (tab, race) => {
  if (tab && !(!isMobile && tab === tabs.SPELA)) {
    return tab;
  }
  let raceHasHighFive = false;
  if (race && race.draws) {
    raceHasHighFive = race.draws.filter(draw => draw.gameType === 'topp5').length > 0;
  }
  if (!isMobile && raceHasHighFive) {
    return tabs.SPELANALYS_HIGH_FIVE;
  }
  if (isSelfService) {
    return tabs.SPELGUIDE;
  }
  if (isMobile) {
    return tabs.SPELA;
  }
  return defaultTab;
};
const useCurrentTab = () => {
  const navigation = useNavigationState();
  const {
    race
  } = useContext(playContext.PlayContext);
  if (navigation.isMyGaming && !navigation.tab) {
    return tabs.MINA_SPEL;
  }
  return determineTab(navigation.tab, race);
};
svs.racing_game.components.hooks.useCurrentTab = useCurrentTab;

 })(window);